const getters = {
  users: state => state.users,
  userFilters: state => state.user_filters,
  userData: state => state.user_data,
}

export default getters;
